/* =========================================================
   WonderCases — Variant media visibility v7.9 (SAFE)
   ----------------------------------------------------
   - Only media bound to the current variant stays visible
     (wc-variant-hidden on all other variant media).
   - Works on desktop + mobile:
       * hero / slider slides (above-mobile + below-mobile)
       * thumbnail rails (desktop + mobile)
   - Hero change uses a synthetic click on the relevant
     DESKTOP thumbnail, so the theme's own gallery logic
     stays in control.
   - Current variant thumbnail(s) get an extra class:
       .wc-variant-thumb-current
     which you can style / reorder via CSS (order: 99 → last).
   - Current thumbnail is scrolled into view and centered
     inside the real scroll container of the rail.
   ========================================================= */
(function () {
  // -------- 0) Root + Product JSON --------
  var root =
    document.getElementById("wc-product-root") ||
    document.querySelector('[data-section-type="product"]');

  if (!root || root.getAttribute("data-is-full-product") !== "true") return;

  var sectionId = root.getAttribute("data-section-id") || "";
  var jsonEl = document.getElementById("ProductJson-" + sectionId);
  if (!jsonEl || !jsonEl.textContent) return;

  var product;
  try {
    product = JSON.parse(jsonEl.textContent);
  } catch (e) {
    console.warn("[WC VariantMedia] JSON parse error", e);
    return;
  }
  if (!product || !Array.isArray(product.variants)) return;

  // 👉 WC — Single-variant products: do NOT toggle media
  var variantCount = product.variants.length || 0;
  if (variantCount <= 1) {
    if (window.WC_DEBUG_VARIANT_MEDIA) {
      console.log(
        "[WC VariantMedia] Single-variant product → skip media visibility logic"
      );
    }
    // Leave all media as the theme renders it, no wc-variant-hidden anywhere
    return;
  }

  // -------- 1) Variant -> featured_media.id mapping --------
  var variantToMediaId = {};
  var variantMediaIds = new Set();

  product.variants.forEach(function (v) {
    if (v && v.id && v.featured_media && v.featured_media.id) {
      var vid = String(v.id);
      var mid = String(v.featured_media.id);
      variantToMediaId[vid] = mid;
      variantMediaIds.add(mid);
    }
  });

  if (!Object.keys(variantToMediaId).length) {
    // No variant-specific hero media → nothing to control
    return;
  }

  // -------- 2) DOM registry --------
  // mediaId -> { slides, thumbsDesktop, thumbsMobile }
  var registry = {};
  var CURRENT_THUMB_CLASS = "wc-variant-thumb-current";

  function bucket(mid) {
    mid = String(mid);
    if (!registry[mid]) {
      registry[mid] = {
        slides: [],
        thumbsDesktop: [],
        thumbsMobile: [],
      };
    }
    return registry[mid];
  }

  // Slides (desktop hero + mobile slider)
  var slideNodes = root.querySelectorAll(
    '.above-mobile .product__media-item[data-media-item-id], .below-mobile .product__media-item[data-media-item-id]'
  );
  Array.prototype.forEach.call(slideNodes, function (slide) {
    var mid = String(slide.getAttribute("data-media-item-id") || "");
    if (!variantMediaIds.has(mid)) return;
    bucket(mid).slides.push(slide);
  });

  // Desktop thumbnails (above-mobile)
  var thumbDesktopNodes = root.querySelectorAll(
    '.above-mobile [data-media-id], .above-mobile [data-product-media-id]'
  );
  Array.prototype.forEach.call(thumbDesktopNodes, function (node) {
    var mid = String(
      node.getAttribute("data-media-id") ||
        node.getAttribute("data-product-media-id") ||
        ""
    );
    if (!variantMediaIds.has(mid)) return;

    var thumb =
      node.closest(".product-thumbnails__item") ||
      node.closest(".product__media-thumbnail") ||
      node.closest("[data-thumbnail]") ||
      node.closest("li") ||
      node;

    if (!thumb) return;

    bucket(mid).thumbsDesktop.push(thumb);
  });

  // Mobile thumbnails (below-mobile)
  var thumbMobileNodes = root.querySelectorAll(
    '.below-mobile [data-media-id], .below-mobile [data-product-media-id]'
  );
  Array.prototype.forEach.call(thumbMobileNodes, function (node) {
    var mid = String(
      node.getAttribute("data-media-id") ||
        node.getAttribute("data-product-media-id") ||
        ""
    );
    if (!variantMediaIds.has(mid)) return;

    var thumb =
      node.closest(".product-thumbnails__item") ||
      node.closest(".product__media-thumbnail") ||
      node.closest("[data-thumbnail]") ||
      node.closest("li") ||
      node;

    if (!thumb) return;

    bucket(mid).thumbsMobile.push(thumb);
  });

  if (!Object.keys(registry).length) {
    // No matching media nodes found
    return;
  }

  // -------- 2b) Helpers to keep thumb fully visible (instant jump) --------
  // Returns the offsetTop of `el` relative to `ancestor`
  function getOffsetTopWithin(el, ancestor) {
    var top = 0;
    var node = el;
    while (node && node !== ancestor && node.offsetParent) {
      top += node.offsetTop;
      node = node.offsetParent;
    }
    return top;
  }

  function ensureThumbVisible(thumb) {
    if (!thumb) return;

    // The real scroll container is the outer thumbnails wrapper,
    // not the inner <ul>.
    var rail =
      thumb.closest(".product-thumbnails.scroll-container-initialize") ||
      thumb.closest(".product-thumbnails");

    if (!rail) return;

    // If there is nothing to scroll, do nothing.
    if (rail.scrollHeight <= rail.clientHeight + 1) return;

    // Compute the thumb position inside the rail
    var thumbTop = getOffsetTopWithin(thumb, rail);
    var thumbHeight = thumb.offsetHeight || 0;

    // We want the thumb roughly centered in the visible area
    var thumbCenter = thumbTop + thumbHeight / 2;
    var targetScrollTop = thumbCenter - rail.clientHeight / 2;

    // Clamp to valid scroll range
    var maxScroll = rail.scrollHeight - rail.clientHeight;
    if (targetScrollTop < 0) targetScrollTop = 0;
    if (targetScrollTop > maxScroll) targetScrollTop = maxScroll;

    // TEMPORARILY force instant scroll (no smooth behavior)
    var previousBehavior = rail.style.scrollBehavior;
    rail.style.scrollBehavior = "auto";

    // Instant jump – no animated scrolling
    rail.scrollTop = targetScrollTop;

    // Restore previous value (if there was any)
    if (previousBehavior) {
      rail.style.scrollBehavior = previousBehavior;
    } else {
      rail.style.removeProperty("scroll-behavior");
    }
  }



  function getScrollRailForThumb(thumb) {
    if (!thumb) return null;

    // Preferred: slider wrapper that actually scrolls
    var slider = thumb.closest(".product-thumbnails__slider");
    if (slider) return slider;

    // Fallback: main thumbnails container
    var container = thumb.closest(".product-thumbnails");
    if (container) return container;

    // Last resort: items list
    var items = thumb.closest(".product-thumbnails__items");
    if (items) return items;

    return null;
  }

  function ensureThumbVisible(thumb) {
    if (!thumb) return;

    var rail = getScrollRailForThumb(thumb);
    if (!rail) return;

    // Only adjust if the rail actually scrolls
    if (rail.scrollHeight <= rail.clientHeight + 1) return;

    var thumbTop = getOffsetTopWithin(thumb, rail);
    var thumbHeight = thumb.offsetHeight || 0;

    // Target: keep the thumb roughly centered in the visible area
    var thumbCenter = thumbTop + thumbHeight / 2;
    var targetScrollTop = thumbCenter - rail.clientHeight / 2;

    // Clamp scrollTop to valid range
    var maxScroll = rail.scrollHeight - rail.clientHeight;
    if (targetScrollTop < 0) targetScrollTop = 0;
    if (targetScrollTop > maxScroll) targetScrollTop = maxScroll;

    rail.scrollTop = targetScrollTop;
  }

  // -------- 3) Current variant ID helper --------
  function getCurrentVariantId() {
    var form =
      root.querySelector('form[action*="/cart/add"]') ||
      root.querySelector("product-form form");

    if (form) {
      var hidden = form.querySelector('input[type="hidden"][name="id"]');
      if (hidden && hidden.value) return String(hidden.value);

      var sel = form.querySelector('select[name="id"]');
      if (sel && sel.value) return String(sel.value);

      var rad = form.querySelector('input[type="radio"][name="id"]:checked');
      if (rad && rad.value) return String(rad.value);
    }

    var attrId = root.getAttribute("data-current-product-id");
    if (attrId) return String(attrId);

    return null;
  }

  // -------- 4) Hero change via desktop thumbnail click --------
  function clickThumbForMedia(mid) {
    mid = String(mid || "");
    if (!mid || !registry[mid]) return;

    var b = registry[mid];
    if (!b.thumbsDesktop.length && !b.thumbsMobile.length) return;

    // Prefer a desktop thumb, fall back to mobile if needed
    var thumb = b.thumbsDesktop[0] || b.thumbsMobile[0];
    if (!thumb) return;

    var clickable =
      thumb.querySelector("[data-media-id]") ||
      thumb.querySelector("[data-product-media-id]") ||
      thumb.querySelector("button") ||
      thumb.querySelector("a") ||
      thumb;

    if (!clickable) return;

    try {
      var evt = new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window,
      });
      clickable.dispatchEvent(evt);
    } catch (err) {
      if (typeof clickable.click === "function") {
        clickable.click();
      }
    }
  }

  // -------- 4b) Mark current variant thumbnails (desktop + mobile) --------
function setCurrentThumb(mid) {
  // 1) Remove marker class from all thumbnails
  Object.keys(registry).forEach(function (id) {
    var b = registry[id];

    b.thumbsDesktop.forEach(function (thumb) {
      thumb.classList.remove(CURRENT_THUMB_CLASS);
    });

    b.thumbsMobile.forEach(function (thumb) {
      thumb.classList.remove(CURRENT_THUMB_CLASS);
    });
  });

  // 2) Add marker class only to the current variant's thumbnails
  mid = String(mid || "");
  if (!mid || !registry[mid]) return;

  var bucketForVariant = registry[mid];

  bucketForVariant.thumbsDesktop.forEach(function (thumb) {
    thumb.classList.add(CURRENT_THUMB_CLASS);
  });

  bucketForVariant.thumbsMobile.forEach(function (thumb) {
    thumb.classList.add(CURRENT_THUMB_CLASS);
  });

  // NOTE:
  // We intentionally do NOT auto-scroll to the current thumbnail here.
  // The theme's own slider controls thumbnail positioning. Forcing
  // scrolling from this script caused jitter, so we only mark the
  // current thumbs and let the user / theme handle movement.
}


  // -------- 5) Visibility logic (desktop + mobile) --------
  function applyVariantMediaVisibility(variantId) {
    var vid = variantId && String(variantId);
    var midToShow =
      vid && Object.prototype.hasOwnProperty.call(variantToMediaId, vid)
        ? String(variantToMediaId[vid])
        : null;

    if (!midToShow) {
      // No selected variant: hide all variant-specific media,
      // always-on media stay untouched.
      Object.keys(registry).forEach(function (mid) {
        var b = registry[mid];
        b.slides.forEach(function (slide) {
          slide.classList.add("wc-variant-hidden");
        });
        b.thumbsDesktop.forEach(function (thumb) {
          thumb.classList.add("wc-variant-hidden");
        });
        b.thumbsMobile.forEach(function (thumb) {
          thumb.classList.add("wc-variant-hidden");
        });
      });
      setCurrentThumb(null);
      return;
    }

    // Selected variant: only its media stays visible
    Object.keys(registry).forEach(function (mid) {
      var b = registry[mid];
      var isCurrent = mid === midToShow;

      b.slides.forEach(function (slide) {
        slide.classList.toggle("wc-variant-hidden", !isCurrent);
      });

      b.thumbsDesktop.forEach(function (thumb) {
        thumb.classList.toggle("wc-variant-hidden", !isCurrent);
      });

      b.thumbsMobile.forEach(function (thumb) {
        thumb.classList.toggle("wc-variant-hidden", !isCurrent);
      });
    });

    // Mark current thumbnails (for CSS order / styling) + keep them visible
    setCurrentThumb(midToShow);

    // Let the theme gallery JS handle hero change via thumbnail click.
    // Small timeout so other variant JS can finish first.
    window.setTimeout(function () {
      clickThumbForMedia(midToShow);
    }, 0);
  }

  // -------- 6) Variant change handler + guard --------
  var lastVariantId = null;

  function handleVariantEvent(e) {
    var variantId = null;

    if (e && e.detail) {
      var d = e.detail;
      if (d.id) variantId = d.id;
      else if (d.variant && d.variant.id) variantId = d.variant.id;
      else if (d.variantId) variantId = d.variantId;
    }

    if (!variantId) {
      variantId = getCurrentVariantId();
    }

    if (!variantId) {
      lastVariantId = null;
      applyVariantMediaVisibility(null);
      return;
    }

    variantId = String(variantId);

    // Skip if this variant is already active
    if (variantId === lastVariantId) return;

    lastVariantId = variantId;
    applyVariantMediaVisibility(variantId);
  }

  function getVariantIdFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      var vid = params.get("variant");
      return vid ? String(vid) : null;
    } catch (e) {
      return null;
    }
  }

  function init() {
    var vid = getVariantIdFromUrl();
    lastVariantId = vid ? String(vid) : null;
    applyVariantMediaVisibility(vid || null);
  }

  // -------- 7) Init timing --------
  // Run once when DOM is ready.
  // Initial page load must only respect an explicit ?variant= URL parameter.
  // Without ?variant=, keep the Liquid-rendered product.featured_media.
  if (
    document.readyState === "complete" ||
    document.readyState === "interactive"
  ) {
    init();
  } else {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  }

  // Extra safety: run a second sync after full window load.
  // Do not infer a variant from hidden/select form values on initial load.
  // If the customer already selected a variant before window.load, do not reset it.
  window.addEventListener("load", function () {
    var vid = getVariantIdFromUrl();

    if (vid) {
      lastVariantId = String(vid);
      applyVariantMediaVisibility(vid);
      return;
    }

    if (lastVariantId) {
      return;
    }

    lastVariantId = null;
    applyVariantMediaVisibility(null);
  });

  // Listen to theme variant change events
  ["variant:change", "variant:changed", "product:variant-change"].forEach(
    function (ev) {
      document.addEventListener(ev, handleVariantEvent, false);
    }
  );

  // Fallback: listen to direct changes on id/options fields
  root.addEventListener(
    "change",
    function (e) {
      var t = e.target;
      if (!t || !t.name) return;
      if (t.name === "id" || /^options\[/.test(t.name)) {
        window.setTimeout(function () {
          handleVariantEvent(null);
        }, 0);
      }
    },
    true
  );
})();